import {
    QuestionAnswerMeta,
    QuestionAnswers,
    StoredAuthToken,
    SuspectedConditions
} from "./Store";
import {get} from "svelte/store";
import {SuspectedCondition} from "../models/SuspectedCondition";
import {PickListItem} from "../models/PickListItem";
import {QuestionAnswer} from "../models/QuestionAnswer";
import {QuestionAnswerData} from "../models/QuestionAnswerData";

export function convertToDateString(date: Date): string {
    if (!date) return '';
    let convertDate = new Date(date);
        let month = (1 + convertDate.getMonth()).toString();
        let day = convertDate.getDate().toString();
        let year = convertDate.getFullYear().toString();
        if (month.length === 1) {
            month = '0' + month;
        }
        if (day.length === 1) {
            day = '0' + day;
        }
        return month + '/' + day + '/' + year;
}


export function convertToCurrency(amount: number): string {
    return amount.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

export function validateField(value: string, pattern: string): boolean{

    if (!value) return false;
    if (pattern) {
        const regex = new RegExp(pattern);
        return regex.test(value);
    }
    return true;
}

export function validateEmail(email: string): boolean {

    if (!email) return false;
    const regex = new RegExp(
        /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
    );
    return regex.test(email);
}

export function validatePhone(phoneNumber: string): boolean {
    if (!phoneNumber) return false;
  //  const regex = new RegExp( /^\(?([0-9]{3})\)?[ ]?([0-9]{3})[-]?([0-9]{4})$/);
    const regex = new RegExp( /^([0-9]{3})?[-]?([0-9]{7})$/);
    return regex.test(phoneNumber);

}

export function validateDate(date: string): boolean {

    if (!date) return false;
    const regex = new RegExp('^((0?[1-9]|1[012])[- /.](0?[1-9]|[12][0-9]|3[01])[- /.](19|20)?[0-9]{2})*$');

    if   (regex.test(date) == false) {
        return false;
    } else {
        const newDate = new Date(date);
        return newDate <= new Date();
    }
}

export function alphaNumericPattern(): string{
    return  "^[a-zA-Z0-9 ]+$";
}



export function getEzAppToken(): string {
    return  get(StoredAuthToken).toString();
}

export function getSuspectedConditionsForBaseQuestion(questionCode: string) {
    let matchedConditions: PickListItem[] = [];
    let suspectedConditions = get(SuspectedConditions) as SuspectedCondition[];

    if (suspectedConditions) {
        suspectedConditions.map(c => {
            if (c.baseQuestionCode === questionCode) {
                const foundCondition = matchedConditions.find(m => m.alias === c.displayAlias);
                if (!foundCondition) {
                    const newPickListItem = new PickListItem(c.displayAlias, false);
                    matchedConditions.push(newPickListItem);
                }
            }
        })
    }
    return matchedConditions;
}

export function updateQuestionsAnswered(questionCode: string, value: string) {
    let questionsAnswered = get(QuestionAnswers) as QuestionAnswer[];
    let meta = get(QuestionAnswerMeta) as QuestionAnswerData;

    let matched = questionsAnswered.find(q => q.questionCode == questionCode.toString());
    if (matched) {
        matched.answer = value;
        const filteredQuestions = questionsAnswered.filter(q => q.questionCode != questionCode) as QuestionAnswer[];
        const newQuestions = [...filteredQuestions, matched] as QuestionAnswer[];
        QuestionAnswers.set(newQuestions);

        let totalQuestions = 0;
        let totalAnswered = 0;
        newQuestions.map(q => {
            totalQuestions++;
            if (q.answer) {
                totalAnswered++;
            }
        });
        const questionAnswerData = new QuestionAnswerData(totalQuestions, totalAnswered);
        QuestionAnswerMeta.set(questionAnswerData);
    }
}
